import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setPartnerTemporaryDisable } from '../services/partners';
import { partnerQueryKeys } from './query-keys';

export const useSetPartnerTemporaryDisableMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ partnerId, temporaryDisable }) => {
      const result = await setPartnerTemporaryDisable({ partnerId, temporaryDisable });
      if (!result.success) {
        throw new Error(
          result.message ||
            (temporaryDisable
              ? 'Failed to disable partner organization'
              : 'Failed to enable partner organization'),
        );
      }
      return result;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: partnerQueryKeys.all });
      options.onSuccess?.(...args);
    },
    ...options,
  });
};
